export default function initDraggable() {
    const containers = document.querySelectorAll('.draggable-contaner');
    if (containers.length == 0) {
        return;
    }

    containers.forEach(function(container) {
        initContainer(container);
    });

    const scrollTrigger = .15;
    const scrollMaxSpeed = 12;
    document.addEventListener('dragover', function (ev) {
        let y = ev.clientY;
        let height = window.innerHeight;
        let triggerHeight = height * scrollTrigger;

        if (y <= triggerHeight) {
            let step = ((triggerHeight - y) / triggerHeight) * scrollMaxSpeed;
            window.scrollBy(0, -step);
        }

        if (y >= (height - triggerHeight)) {
            let step = ((triggerHeight - (height - y)) / triggerHeight) * scrollMaxSpeed;
            window.scrollBy(0, step);
        }
    })
}

function initContainer(container) {
    let items = container.querySelectorAll('.draggable-item');
    if (items.length == 0) {
        return;
    }

    items.forEach(function(item, index, items) {
        initItem(item, index, items);
    });
}

function initItem(item, index, items) {
    let control = item.querySelector('.draggable-control');
    if (!control) {
        return;
    }

    let itemIndex = control.getAttribute('drag-index');

    control.addEventListener('mousedown', function (ev) {
        item.setAttribute('draggable', 'true');
    });

    control.addEventListener('mouseup', function (ev) {
        item.removeAttribute('draggable');
        dropzoneState(item, items, false);
    });


    item.addEventListener('dragstart', function (ev) {
        ev.dataTransfer.setData('text/plain', itemIndex);
        dropzoneState(item, items, true);
    });

    item.addEventListener('dragend', function (ev) {
        ev.preventDefault();
        item.removeAttribute('draggable');
        dropzoneState(item, items, false);
    });

    initItemDropzone(item, control);
}

function dropzoneState(dragItem, items, state) {
    items.forEach(function (item) {
        if (item.isEqualNode(dragItem)) {
            return;
        }

        let dropZone = item.querySelector('.dropzone');
        if (!dropZone) {
            return;
        }

        if (state) {
            dropZone.classList.add('active');
            return;
        }

        dropZone.classList.remove('active');
    });
}

function initItemDropzone(item, control) {
    let dropZone = item.querySelector('.dropzone');
    if (!dropZone) {
        return;
    }

    if (document.querySelector('.index-page')) {
        return initItemDropzoneIndex(item, dropZone, control);
    }
}

function initItemDropzoneIndex(item, dropZone, control) {
    let fit = dropZone.querySelector('.fit');
    let swap = dropZone.querySelector('.swap');

    if (!fit || !swap) {
        return;
    }

    let destIndex = control.getAttribute('drag-index');

    fit.addEventListener('dragover', function (ev) {
        ev.preventDefault();
        fit.classList.add('dragover');
    });
    fit.addEventListener('dragleave', function (ev) {
        ev.preventDefault();
        fit.classList.remove('dragover');
    });
    fit.addEventListener('drop', function (ev) {
        ev.preventDefault();
        fit.classList.remove('dragover');
        let sourceIndex = ev.dataTransfer.getData('text/plain');
        submitIndexLayout(sourceIndex, destIndex, 'fit');
    });


    swap.addEventListener('dragover', function (ev) {
        ev.preventDefault();
        swap.classList.add('dragover');
    });
    swap.addEventListener('dragleave', function (ev) {
        ev.preventDefault();
        swap.classList.remove('dragover');
    });
    swap.addEventListener('drop', function (ev) {
        ev.preventDefault();
        swap.classList.remove('dragover');
        let sourceIndex = ev.dataTransfer.getData('text/plain');
        submitIndexLayout(sourceIndex, destIndex, 'swap');
    });
}

function submitIndexLayout(sourceIndex, destIndex, action) {
    const layoutUrl = '/admin/layout';

    let body = new FormData();
    body.append(yii.getCsrfParam(), yii.getCsrfToken());
    body.append('source', sourceIndex);
    body.append('dest', destIndex);
    body.append('action', action);
    body.append('target', 'index');

    fetch(layoutUrl, {
        method: 'POST',
        body: body,
    })
        .then(resp => resp.json())
        .then(answ => {
            if (answ.ok) {
                // @note location.reload() почему-то не работает
                window.location.href = window.location.href;
                return;
            }
            // @todo надо как-то вывести ошибочки
        })
        .catch(err => {
            console.error(err);
        });
}
